// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content .media{\n  display:block;\n  min-width:15em\n}[dir] .ck-content .media{\n  clear:both;\n  margin:1em 0\n}", ""]);
// Exports
module.exports = exports;
